<template>
  <FadeTransition>
    <div>
      <div class="-m-3 flow-root">
        <iframe
          id="flockler-hs"
          :src="url"
          class="ml-[11px] block h-[1006px] w-[1920px] border-none"
        />
      </div>
    </div>
  </FadeTransition>
</template>

<script lang="ts" setup>
const props = defineProps({ id: { type: String, require: true } });
const url = computed(
  () =>
    `https://plugins.flockler.com/social-screen/17fac54f2590fd4beb5f9407439d5b58/${props.id}`
);
</script>
